module.exports = __webpack_public_path__ + "img/purchase_01.b442333e.png";